<template>
    <div>
        <form enctype="multipart/form-data" novalidate>
            <input
                    v-show="false"
                    id="fileSelector"
                    type="file"
                    :multiple="multiple"
                    class="input-file"
                    :name="uploadFieldName"
                    :accept="accept"
                    @change="onSelectFiles($event.target.files)"
            />
            <button class="anexo-button" @click.prevent="openFileSelector()">
                Inserir Anexo
            </button>
        </form>
    </div>
</template>

<script>

    export default {
        name: 'botao-anexo',
        props: {
            accept: {
                type: String,
                default: '*'
            },
            repository: {
                type: String,
                required: true
            },
            thumbnail: {
                type: Boolean,
                default: false
            },
            height: {
                type: String,
                default: '200px'
            },
            multiple: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                uploadFieldName: 'file',
                files: []
            }
        },
        methods: {
            calcFileSize(bytes, unit) {
                const k = 1024
                return parseFloat((bytes / Math.pow(k, unit)).toFixed(2))
            },
            getMaxSizeConfig() {
                const fileConfig = this.$store.state.loki.file
                const maxSize = fileConfig.maxSize.replace(/([A-Za-z]+)/g, '')
                const unit = ['B', 'KB', 'MB', 'GB', 'TB'].indexOf(fileConfig.maxSize.replace(/\d+/g, '').toUpperCase())
                return { maxSize, unit }
            },
            isFileBiggerThanExpected(file) {
                const { maxSize, unit } = this.getMaxSizeConfig()
                const fileSize = this.calcFileSize(file.size, unit)
                return fileSize > maxSize
            },
            onSelectFiles(fileList) {
                if (!fileList.length) {
                    return
                }
                this.uploadFiles(fileList)
                this.resetSelectedFiles()
            },
            openFileSelector() {
                document.getElementById('fileSelector').click()
            },
            uploadFiles(fileList) {
                Array.from(Array(fileList.length).keys()).forEach(x => {
                    const file = fileList[x]
                    if (this.isFileBiggerThanExpected(file)) {
                        this.throwFileExceedMaxLimitSizeEvent(file)
                    } else {
                        this.$emit('fileSelect', file)
                    }
                })
            },
            resetSelectedFiles() {
                document.getElementById('fileSelector').value = ''
            },
            throwFileExceedMaxLimitSizeEvent(file) {
                this.mostrarNotificacaoErro('O arquivo ' + file.name + ' ultrapassa o tamanho máximo permitido de 30MB.')
            }
        }
    }
</script>

<style scoped lang="stylus">

</style>